<template >
  <v-app class="responsive" id="layout">
    <v-app-bar app clipped-left fixed elevation="2" class="app_bar_bg" id="layoutAppBar">
        <v-toolbar-title class="flex text-center">Weather Information System</v-toolbar-title>
        <!-- Show Logout Info -->
        <div class="text-center"> 
        <v-menu offset-y min-width="180">
          <template v-slot:activator="{ on }">
            <v-btn icon large v-on="on">
              <v-icon color="app_bar_title">$person</v-icon>
            </v-btn>
          </template>
          <v-list class="text-center px-2" id="my-info" color="menu_bg menu_title--text">
            <v-avatar color="secondary darken-2" class="mb-2">
              <span class="menu_title--text text-h6">{{ user.initials }}</span>
            </v-avatar>
            <h3>{{ user.fullName }}</h3>
            <p class="text-caption mt-1">{{ user.makerNm }}</p>
          
            <v-divider class="my-1"></v-divider>
            <v-btn depressed rounded text class="px-3" color="menu_title" @click="logout()">Logout</v-btn>
          </v-list>
        </v-menu>
      </div> 
     </v-app-bar>

     <v-main
        class="fill-height container_bg content--text"
        id="mainContent"
        :style=img_bg_style
      > 
          <!-- <div > -->
          <v-item-group mandatory class="mt-1" >
            <v-container >
              <v-row justify="center" d-flex justify-center flex-wrap >
                <v-col 
                v-for="(item, index) in gridLists"
                  :key="index"
                  cols="auto"
                >
                  <v-item v-slot="{ active, toggle }">
                      <div>
                        <v-card 
                          :color="active ? 'green' : 'white'"
                          :class="active ? 'borderme' : 'borderout'"              
                          class="elevation-3"
                          dark
                          :height= window.h 
                          :width= window.w 
                          :style="{'border-radius':'25px'}"                  
                          @click="goList(item.menuId, item.pgmId, item.linkAddr)"                          
                          flat
                        >
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center"              
                          >
                          
                            <div align="center" justify="center">
                              <v-img 
                                :height= window.h
                                :width= window.w
                                :style="{'border-radius':'25px'}"
                                :src="item.imgButton"
                              ></v-img>
                            </div>

                          </v-row>
                        </v-card>
                    
                        <v-card :class="active ? 'green--text' : 'white--text'"
                              flat style="background-color: transparent; text-shadow: 1px 1px 2px black, 0 0 1em blue, 0 0 0.2em blue; font-size:small"
                              class="my-2 text-center"
                              :width= window.w 
                              height="auto"
                              @click="toggle" >
                            {{ item.ename }}
                        </v-card>
                      </div>
                    </v-item>            
                
                </v-col>
              </v-row>
            </v-container> 

          </v-item-group>
        <!-- </div>  -->
      </v-main>

  </v-app>
</template>
  
<script>
  import ResizeMixin from '@/layout/mixin/ResizeHandler'
  import { mapState } from 'vuex'
  import { fn_Logout } from '@/framework/login/login'
  import localStore from "@/utils/localStore";
  import VueToastify from '@/components/toastify/VueToastify.vue'
  

  import {
    getSideMenu
  } from '@/api/system/menuManage'
  
  export default {
    name: 'mainLayout',
    data() {
      return {
        userData: {
          userId: '',
          userPw: '',
          sysId: '',
          system: '',
        },
        user: {
          initials: '',
          fullName: '',
          email: ''
        },
        userInfo: null,
        active: false,       
        gridLists: [],
        image: require(`@/assets/images/bg/bg_login.jpg`),

        window: {
            w: 0,
            h: 0,
      }
      }
    },  

    created() {
        let initial = ''
        const arrName = this.$store.state.user.userNm.split(' ')
        for(let i = 0; i < arrName.length; i++) {
          initial += arrName[i].substr(0, 1)
        }

        this.user = {
          initials: initial,
          fullName: this.$store.state.user.userNm,
          makerNm: this.$store.state.user.deptNm
        }

        this.userInfo = {
          userId: this.$store.state.user.userId,
          sysCd: '20',//this.$store.state.system.sysCd,
          sysId: this.$store.state.system.sysId
        }

        this.setLocale()

        // this.$EventBus.$on('App_Bar_MenuClick', e => {
        //   this.menuClick(e)
        // })
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.$router.push({ name: 'v20Menu' }) ;  // 👉 Điều hướng ngay tại đây
    this.searcGridList()
    // console.log('w', this.window.w)
    // console.log('h', this.window.h)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },


  computed: {
    img_bg_style: function(){
      var bgImg= this.image

      return {
                "height": "100%",
                "background-image": 'url(' + bgImg + ')', 
                "background-repeat": "no-repeat", 
                "background-size": "cover",
                "background-position": "center",
                "opacity": "1"
      }
    },
  },  
  methods: { 
    setLocale() {
    // if (this.$localStore.get('locale') == 'ko') {
    //   this.activeLang = this.$envs.framework.supportLocales.ko
    //   this.$vuetify.lang.current = 'ko'
    //   this.$i18n.locale = 'ko'
    // } else {
      this.activeLang = this.$envs.framework.supportLocales.en
      this.$vuetify.lang.current = 'en'
      this.$i18n.locale = 'en'
    // }
    // this.$store.dispatch('GetMenus', this.userInfo)
    // GetGridMenu
    this.$store.dispatch('GetGridMenu', this.userInfo)
    this.$EventBus.$emit('lanCode', this.$localStore.get('locale'))  
    },
    // log out
    logout() {
      fn_Logout()
    },
    handleResize() {
    
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= '569' ){
        this.window.w   = 65;
        this.window.h   = 65;
      }else{
        this.window.w   = 75;
        this.window.h   = 75;
      }
      

      // console.log('handleResize w', this.window.w )
      // console.log('handleResize h', this.window.h)
      // console.log('window.innerHeight', window.innerHeight )
      //Full screen or not
      this.$store.dispatch('app/setIsScreenFull', window.innerHeight == screen.height)
    },
    searcGridList() {
      this.gridLists = []

      getSideMenu().then(res => {
        // console.log('res', res.list)

        this.gridLists = res.list
      })
    },


    goList(id, pgm, link) {

      this.$store.commit('system/SET_SYS_CD', id)
      this.$store.commit('system/SET_SYS_ID', id)
      
      // console.log('#######id===>', id )      
      // console.log('#######pgm===>', pgm )  
      // console.log('#######link===>', link )

      if (pgm == null||pgm == ''){
        //  console.log('#######link===>', link )
        // window.location.href = 'http://smart.hvs.com.vn:7001/pp/';
        if  (id === '60') {
          link = link + "/#/ssoLogin?id=" + this.userInfo.userId;
        }else 
          link = link + ""
        
        // console.log('#######link===>', link )
        window.open(link)

      }else{
        
          let view = ''
          view = '/' + pgm
        //  console.log('view', view )

        if(view) {
          this.$router.push(view).catch((e => {
            // console.log('Error', e)
            this.vToastify(this.$t('View does not exist.'), 'warn')
          }));
        }

      }
      
      
    },
  }, 
   
}

</script>
  
<style lang="scss" scoped>

.app_bar_bg {
      border-radius: 0px;
      background: linear-gradient(90deg, #3df383 0%, #039233 100%);
      color: #ffffff !important;
      font-weight: bold;
      font-size: 18px !important;
  }
 
  </style>